import {
  getAllPayrollService,
  updateApprovedHoursService,
  updateReOpenHoursService,
  updateRejectedHoursService
} from 'Services/Payroll'
import { createQueryString } from 'Utils/helperFunctions'
import { useState } from 'react'

// Luxon DateTime instances serialize fine implicitly (toJSON/toString both call toISO()),
// but we make it explicit here so the payload is guaranteed to be a plain ISO 8601 string
// regardless of what's passed in (Luxon DateTime, native Date, or an already-formatted string).
const toISODateString = (date) => (date && typeof date.toISO === 'function' ? date.toISO() : date)

export default function usePayroll () {
  const [loadingPayrollHook, setLoadingPayrollHook] = useState(false)
  const [payrollHook, setPayrollHook] = useState([])

  const getAllPayroll = async ({ startDate, endDate, user_id, is_approved, project_ids, users_ids }) => {
    try {
      setLoadingPayrollHook(true)
      const query = createQueryString({
        date: startDate && endDate ? `${startDate}:${endDate}` : '',
        is_approved,
        user_id,
        project_ids,
        users_ids
      })
      const payroll = await getAllPayrollService({ query })
      setPayrollHook(payroll?.data || [])
      return payroll?.data || []
    } catch (e) {
      console.error(e)
    } finally {
      setLoadingPayrollHook(false)
    }
  }

  const handleUpdateApprovedHoursHook = async ({ startDate, endDate, user_id, project_ids }) => {
    try {
      setLoadingPayrollHook(true)
      await updateApprovedHoursService({
        body: {
          start_date: toISODateString(startDate),
          end_date: toISODateString(endDate),
          user_id,
          project_ids
        }
      })
      return { success: true }
    } catch (e) {
      return { success: false }
    } finally {
      setLoadingPayrollHook(false)
    }
  }

  const handleUpdateReOpenHoursHook = async ({ startDate, endDate, user_id, project_ids, note }) => {
    try {
      setLoadingPayrollHook(true)
      await updateReOpenHoursService({
        body: {
          start_date: toISODateString(startDate),
          end_date: toISODateString(endDate),
          user_id,
          project_ids,
          note
        }
      })
      return { success: true }
    } catch (e) {
      return { success: false }
    } finally {
      setLoadingPayrollHook(false)
    }
  }

  const handleUpdateRejectHoursHook = async ({ startDate, endDate, user_id, project_ids, comment }) => {
    try {
      setLoadingPayrollHook(true)
      await updateRejectedHoursService({
        body: {
          start_date: toISODateString(startDate),
          end_date: toISODateString(endDate),
          user_id,
          project_ids,
          comment
        }
      })
      return { success: true }
    } catch (e) {
      return { success: false }
    } finally {
      setLoadingPayrollHook(false)
    }
  }

  return {
    loadingPayrollHook,
    payrollHook,
    getAllPayroll,
    handleUpdateApprovedHoursHook,
    handleUpdateReOpenHoursHook,
    handleUpdateRejectHoursHook
  }
}
